export default "__VITE_ASSET__DfVpQToN__"